module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_6-23bd4e39537aeb90388369ce1f513cb4.jpg";